module.exports = __webpack_public_path__ + "media/images/smart_phone/prev-horizontal-8f27d4da0dd06a220eb2a17e843adb90.png";